import { authAction } from '../modules';

/**
 * Middleware to handle authorization errors (401, 403).
 */
export const handleAuthorization =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    const { payload } = action;

    const token = localStorage.getItem("token");
    const requestUrl = payload?.error?.config?.url || "";
    const isPublicRequest = requestUrl.includes("/public/");

    // Sadece oturum açmış bir kullanıcının korumalı isteği 401/403 alırsa
    // zorla logout + login'e yönlendir. Public akışlarda (login, şifremi
    // unuttum, yeni şifre belirleme) 401/403 bir iş kuralı/yetki hatasıdır
    // ve ilgili sayfa tarafından ele alınır — kullanıcıyı login'e atma.
    if (
      (payload?.status === 401 || payload?.status === 403) &&
      token &&
      !isPublicRequest
    ) {
      dispatch(authAction.logout());
      window.location.href = "/login";
    } else {
      next(action);
    }
  };
